import useRootSelector from 'common/hooks/useRootSelector';

export const usePersonSelectorTemplate = (personId: number) => (
  selector: (selectPersonId: number) => any,
  // eslint-disable-next-line react-hooks/rules-of-hooks
): any => useRootSelector(selector(personId));
